// Bloquea "Añadir al carrito" hasta que el cliente acepte el tiempo de fabricación, en los
// productos marcados con el tag "acuerdo-fabricacion". Cubre el botón principal, el sticky, y el
// "agregar rápido" de colecciones (que redirige a la página del producto para que vean el toggle).
(function () {
  if (window.__acuerdoFabCargado) return;
  window.__acuerdoFabCargado = true;

  function checkbox() {
    return document.getElementById("acuerdo-fabricacion");
  }
  function faltaAceptar() {
    var c = checkbox();
    return c && !c.checked; // hay toggle en la página y aún no lo activan
  }
  function avisar() {
    var wrap = document.querySelector("[data-acuerdo]");
    if (!wrap) return;
    var err = wrap.querySelector(".acuerdo-fabricacion__error");
    if (err) err.hidden = false;
    wrap.classList.add("acuerdo-fabricacion--resaltar");
    wrap.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(function () { wrap.classList.remove("acuerdo-fabricacion--resaltar"); }, 2500);
  }

  // Cualquier botón de agregar (principal o sticky). Captura = corre ANTES del handler del tema.
  document.addEventListener("click", function (e) {
    var boton = e.target.closest(".single-add-to-cart-button");
    if (!boton) return;
    if (faltaAceptar()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      avisar();
    }
  }, true);

  // Al activar el toggle, oculta el mensaje de error.
  document.addEventListener("change", function (e) {
    if (e.target && e.target.id === "acuerdo-fabricacion" && e.target.checked) {
      var wrap = document.querySelector("[data-acuerdo]");
      var err = wrap && wrap.querySelector(".acuerdo-fabricacion__error");
      if (err) err.hidden = true;
    }
  });

  // "Agregar rápido" en colecciones: si el producto exige acuerdo, no lo agrega directo —
  // lo lleva a la página del producto para que vea y acepte el toggle.
  document.addEventListener("click", function (e) {
    var qa = e.target.closest('.product-card--add-to-cart-button-simple[data-requiere-acuerdo="true"]');
    if (!qa) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var url = qa.getAttribute("data-product-url");
    if (url) window.location.href = url;
  }, true);
})();
